import { useTranslate } from 'ra-core'
import { SelectInput, useResourceContext } from 'react-admin'

export const EnumSelectInput = ({ source, options = [], translateArgs = {}, translationPrefix, ...props }) => {
  const resource = useResourceContext()
  const translate = useTranslate()

  translationPrefix = translationPrefix ?? `resources.${resource}.enums.${source}.values`

  const choices = options.reduce(
    (acc, choice) => [
      ...acc,
      {
        id: choice,
        name: translate(`${translationPrefix}.${choice.toLowerCase()}`, { ...translateArgs }),
      },
    ],
    [],
  )

  return <SelectInput source={source} choices={choices} {...props} />
}
